if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();

        this.section = this.closest('related-products');
        this.sectionId = this.section?.dataset.sectionId;
        this.howManyToShow = parseInt(this.dataset.limit) || 3;
      }

      connectedCallback() {
        Shopify.Products.showRecentlyViewed({
          howManyToShow: this.howManyToShow,
          wrapperId: `recently-viewed-products-${this.sectionId}`,
          section: this.section,
          onComplete: (wrapper) => {
            wrapper.parentElement.dispatchEvent(new CustomEvent('theme:recently-viewed:loaded', {bubbles: false}));
          },
        });
      }
    }
  );
}
